// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataCollapseTable_wrapper__3dq8M","nameCell":"DataCollapseTable_nameCell__2fm4Z"};